// enquiry.js
document.addEventListener("DOMContentLoaded", function() {
  const enquiryBtn = document.getElementById("enquiryBtn");
  const enquiryForm = document.getElementById("enquiryForm");
  const ajaxForm = document.getElementById("ajaxEnquiryForm");
  const responseDiv = document.getElementById("enquiryResponse");

  // Show form when button clicked
  if(enquiryBtn){
    enquiryBtn.addEventListener("click", () => {
      enquiryForm.style.display = "block";
      enquiryForm.scrollIntoView({ behavior: "smooth" });
    });
  }

  // Handle AJAX submission
  if(ajaxForm){
    ajaxForm.addEventListener("submit", function(e){
      e.preventDefault();
      const formData = new FormData(ajaxForm);

      fetch("/contact", {
        method: "POST",
        body: formData
      })
      .then(res => res.text())
      .then(() => {
        responseDiv.innerHTML = "<p class='enquiry-success'>✅ Enquiry sent successfully!</p>";
        ajaxForm.reset();
      })
      .catch(() => {
        responseDiv.innerHTML = "<p class='enquiry-error'>❌ Error sending enquiry. Please try again.</p>";
      });
    });
  }
});
